/** The Trodo mark and wordmark, set as on trodo.ai (caps, 0.16em tracking), with the product name after a hairline. */
export function LogoMark({ size = 20 }: { size?: number }) {
  return <img src="/brand/trodo-mark.svg" alt="" width={size} height={size} className="block shrink-0" style={{ width: size, height: size }} />
}

export function Wordmark({ product = 'Console' }: { product?: string | null }) {
  return (
    <span className="inline-flex items-center gap-[9px] text-ink">
      <LogoMark />
      <span className="pt-px text-[13px] font-medium leading-none tracking-[0.16em]">TRODO</span>
      {product && (
        <>
          <span className="h-3.5 w-px bg-[color:var(--border-strong)]" aria-hidden />
          <span className="text-[13px] leading-none text-ink-muted">{product}</span>
        </>
      )}
    </span>
  )
}
